module.exports = "/_next/static/images/logo-aman-21029b239d630a4bd4c0b097bf091f96.svg";